import setAuthToken from "../config/setAuthToken";
import { _auth } from "./_auth";

const { postRequest, getRequest } = require("./ApiRequest");

export const Projects = {
  async getRandomCodename() {
    let data = {};
    console.log("Call getRandomCodename API and pass data", data);
    let profile = _auth.profile();
    let token = _auth.getUserToken("jwtToken");
    setAuthToken(token.replace(/"([^"]+(?="))"/g, "$1"));

    data.tenantId = profile.tenantId;
    data.companyId = profile.companyId;
    console.log("API body", data);
    let response = await getRequest("codenames/get-random-codename", data);
    if (response) {
      console.log("getRandomCodename got response", response.data.codename);
      return response.data.codename;
    } else {
      return response;
    }
  },
  async updateCodename() {},
  async create(data, updateCodename) {
    console.log("Call API and pass data", data);
    let profile = _auth.profile();
    let token = _auth.getUserToken("jwtToken");
    setAuthToken(token.replace(/"([^"]+(?="))"/g, "$1"));
    data.updateCodename = updateCodename;
    data.tenantId = profile.tenantId;
    data.companyId = profile.companyId;
    console.log("createProject API body", data);
    let response = await postRequest("projects/create", data);
    if (response) {
      console.log("Create project got response");
      return response.data.data;
    } else {
      return response;
    }
  },
  async list(scope, page) {
    let data = {};
    console.log("Call API and pass data", data);
    let profile = _auth.profile();
    let token = _auth.getUserToken("jwtToken");
    setAuthToken(token.replace(/"([^"]+(?="))"/g, "$1"));
    data.scope = scope;
    data.page = page;
    data.tenantId = profile.tenantId;
    data.companyId = profile.companyId;

    console.log("API body - list projects", data);
    let response = await postRequest("projects/get-projects", data);
    if (response) {
      return response.data.data;
    } else {
      return response;
    }
  },
  async getById(data) {
    // let data = {};
    console.log("Call API and pass data", data);
    let profile = _auth.profile();
    let token = _auth.getUserToken("jwtToken");
    setAuthToken(token.replace(/"([^"]+(?="))"/g, "$1"));

    data.tenantId = profile.tenantId;
    data.companyId = profile.companyId;
    console.log("API body - getById Project", data);
    let response = await postRequest("projects/get-by-id", data);
    if (response && response.data && response.data.status == 200) {
      return response.data.data;
    } else {
      return response;
    }
  },
  async getAllProjectBids(data) {
    console.log("Call API and pass data", data);
    let profile = _auth.profile();
    let token = _auth.getUserToken("jwtToken");
    setAuthToken(token.replace(/"([^"]+(?="))"/g, "$1"));

    data.tenantId = profile.tenantId;
    data.companyId = profile.companyId;
    console.log("API body - list projects", data);
    let response = await postRequest("projects/get-bids-by-project-id", data);
    if (response) {
      return response.data.data;
    } else {
      return response;
    }
  },
  async delete(id) {
    let data = {};
    console.log("Call API and pass data", data);
    let profile = _auth.profile();
    let token = _auth.getUserToken("jwtToken");
    setAuthToken(token.replace(/"([^"]+(?="))"/g, "$1"));
    data._id = id;
    data.tenantId = profile.tenantId;
    data.companyId = profile.companyId;
    console.log("API body - delete project by id", data);
    let response = await postRequest("projects/delete-by-id", data);
    if (response) {
      return response.data.data;
    } else {
      return response;
    }
  },
  async updateProject(data) {
    console.log("Call API and pass data", data);
    let profile = _auth.profile();
    let token = _auth.getUserToken("jwtToken");
    setAuthToken(token.replace(/"([^"]+(?="))"/g, "$1"));

    data.tenantId = profile.tenantId;
    data.companyId = profile.companyId;
    console.log("API body - projects/update-project-by-id", data);
    let response = await postRequest("projects/update-project-by-id", data);
    if (response) {
      return response.data.data;
    } else {
      return response;
    }
  },
  async closeAndReopenProject(data) {
    console.log("Call API and pass data", data);
    let profile = _auth.profile();
    let token = _auth.getUserToken("jwtToken");
    setAuthToken(token.replace(/"([^"]+(?="))"/g, "$1"));

    data.tenantId = profile.tenantId;
    data.companyId = profile.companyId;
    console.log("API body - projects/close-and-reopen-project", data);
    let response = await postRequest("projects/close-and-reopen-project", data);
    if (response) {
      return response.data.data;
    } else {
      return response;
    }
  },
  async removeConnection(data) {
    console.log("Call API and pass data", data);
    let profile = _auth.profile();
    let token = _auth.getUserToken("jwtToken");
    setAuthToken(token.replace(/"([^"]+(?="))"/g, "$1"));

    console.log("API body - projects/remove-connection", data);
    let response = await postRequest("projects/remove-connection", data);
    if (response) {
      return response.data.data;
    } else {
      return response;
    }
  },
  async addConnection(data) {
    let profile = _auth.profile();
    let token = _auth.getUserToken("jwtToken");
    setAuthToken(token.replace(/"([^"]+(?="))"/g, "$1"));
    data.tenantCompany = profile.tenantCompanyId;
    console.log("Call API and pass data", data);
    console.log("API body - projects/add-connection", data);
    let response = await postRequest("projects/add-connection", data);
    if (response) {
      return response.data.data;
    } else {
      return response;
    }
  },
};
